import { Locale } from '@ps-smart-cp/ppfw-client';

const reLeaseFeeCalcClassConfig = {
  reLeaseFeeCalcOneTen: new Map([[Locale.ja, '基本リース料年額の1/10']]),
  reLeaseFeeCalcOneTwelve: new Map([[Locale.ja, '基本リース料年額の1/12']]),
  reLeaseFeeCalcManualInput: new Map([[Locale.ja, '手入力']]),
  unSetting: new Map([[Locale.ja, '未設定']]),
};

export { reLeaseFeeCalcClassConfig };
